import axios from 'axios';
import { getHeaders } from './authService';
import store from "../store";
import { getFlavourBaseAPIURL } from '@/flavors';
import verFlavor from "@/appFlavorAndVersion";

export async function securePostAPI(data, path, showLoading = true) {
  console.log("securePostAPI", data, path,store.getters.apiBaseUrl);
  

  store.commit('loading', showLoading)
  return axios.post(store.getters.apiBaseUrl + path, data, {
    headers: getHeaders()
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function securePostAPIWithoutOverlay(data, path) {

  return axios.post(store.getters.apiBaseUrl + path, data, {
    headers: getHeaders()
  }).then(res => {
    return res.data
  }).catch(err => {
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function securePostAPIWithoutHeadersWithoutOverlay(data, path) {
  return axios.post(store.getters.apiBaseUrl + path, data).then(res => {
    return res.data
  }).catch(err => {
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function securePutAPIWithoutOverlay(data, path, headers) {
  const header = {...getHeaders() , ...headers};
  return axios.put(store.getters.apiBaseUrl + path, data, {
    headers:  header
  }).then(res => {
    return res.data
  }).catch(err => {
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function secureGetAPI(data, path, loadingRequired = true) {
  loadingRequired ? store.commit('loading', true) : ''
  return axios.get(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function secureDeleteAPI(data, path) {
  store.commit('loading', true)
  return axios.delete(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function secureGetAPIWithCredentials(data, path) {
  /*store.commit('loading', true)
  return axios.get(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
    withCredentials: true,
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });*/
  fetch(store.getters.apiBaseUrl + path, {
    credentials: 'include',
    headers: getHeaders()
  })
    .then(async response => {
      const data = await response.json();

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response statusText
        const error = (data && data.message) || response.statusText;
        console.log(JSON.stringify(error));
        return Promise.reject(error);
      }

      return data;
    })
    .catch(error => {
      this.errorMessage = error;
      console.log("There was an error!", error);
    });
}


export async function secureGetAPIWithoutOverlay(data, path) {
  return axios.get(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
  }).then(res => {
    return res.data
  }).catch(err => {
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

// special function to be called initially once to retrieve api urls and other properties from server.]
export async function fetchAPIUrls() {
  store.commit('loading', true)
  let req = { appFlavour: verFlavor.APP_FLAVOR, versionNumber: verFlavor.APP_VERSION }
  return axios.post(getFlavourBaseAPIURL() + 'mysa/api/url', req, {
    headers: getHeaders(),
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function referralAPI(rollNumber) {
  const BASE_URL = store.getters.apiBaseUrl
  return axios.get(`${BASE_URL}mysa/referral-data?rollNumber=${rollNumber}`).then(res => res.data)
  .catch(err => {
    console.log('Error fetching referral details', err)
  })
}

